module.exports = __webpack_public_path__ + "img/高速扫描仪.335a8bd2.jpg";